import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import Check from 'components/Buttons/Check';
import { formatDateToISO, formatToDateCustom } from 'utils/functions';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import SelectInput from 'components/SelectInput';
import {
	optionsWeightFont,
	optionsCentralizeFocusText,
	optionsSizeText
} from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';

export interface DataInputsFocusTextProps {
	name: string;
	nameWeight: string;
	sizeName: string;
	description: string;
	descriptionWeight: string;
	countdown: boolean;
	centralizeText: string;
	schedule_start: string;
	schedule_end: string;
}

const initialState: DataInputsFocusTextProps = {
	name: '',
	sizeName: '',
	nameWeight: '',
	description: '',
	descriptionWeight: '',
	countdown: false,
	centralizeText: '',
	schedule_start: '',
	schedule_end: ''
};

export default function InputsFocusText() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] =
		useState<DataInputsFocusTextProps>(initialState);

	function findeOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function findeOptionOnListByOption(
		value: string,
		list: SelectInputItemProps[]
	) {
		const itemsList = list.filter((item) => item.option === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		setTimeout(() => {
			if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}
		}, 100);
	}, []);

	return (
		<S.container>
			<S.twoInputs>
				<SimpleInput
					label="Título"
					initialValue={dataForm.name}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, name: value }));
					}}
				/>

				<SelectInput
					list={optionsWeightFont}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							nameWeight: value === '' ? value : (value?.option as string)
						}));
					}}
					initialValue={
						dataForm.nameWeight === ''
							? ''
							: findeOptionOnListByOption(
									dataForm.nameWeight || '',
									optionsWeightFont
								)
					}
					label="Peso da fonte do título"
				/>
			</S.twoInputs>

			<S.twoInputs>
				<SimpleInput
					label="Subtítulo"
					initialValue={dataForm.description}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, description: value }));
					}}
				/>

				<SelectInput
					list={optionsWeightFont}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							descriptionWeight:
								value === '' ? value : (value?.option as string)
						}));
					}}
					initialValue={
						dataForm.descriptionWeight === ''
							? ''
							: findeOptionOnListByOption(
									dataForm.descriptionWeight || '',
									optionsWeightFont
								)
					}
					label="Peso da fonte do subtítulo"
				/>
			</S.twoInputs>

			<S.twoInputs style={{ marginBottom: '100px' }}>
				<SelectInput
					list={optionsSizeText}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							sizeName: value === '' ? value : (value?.id as string)
						}));
					}}
					initialValue={
						dataForm.sizeName === ''
							? optionsSizeText[1]
							: findeOptionOnListById(dataForm.sizeName || '', optionsSizeText)
					}
					label="Tamanho do título"
				/>

				<SelectInput
					list={optionsCentralizeFocusText}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							centralizeText: value === '' ? value : (value?.id as string)
						}));
					}}
					initialValue={
						dataForm.centralizeText === ''
							? optionsCentralizeFocusText[0]
							: findeOptionOnListById(
									dataForm.centralizeText || '',
									optionsCentralizeFocusText
								)
					}
					label="Centralização do texto"
				/>
			</S.twoInputs>

			<div style={{ display: 'none' }}>
				<S.inputsDate>
					<SimpleInput
						typeInput="datetime-local"
						label="Ínicio"
						initialValue={
							dataForm.schedule_start === ''
								? ''
								: formatToDateCustom(dataForm.schedule_start)
						}
						getValue={(value: string) => {
							setDataForm((obj) => ({
								...obj,
								schedule_start: formatDateToISO(value)
							}));
						}}
						paddingInLineEnd
					/>

					<SimpleInput
						typeInput="datetime-local"
						label="Fim"
						initialValue={
							dataForm.schedule_end === ''
								? ''
								: formatToDateCustom(dataForm.schedule_end)
						}
						getValue={(value: string) => {
							setDataForm((obj) => ({
								...obj,
								schedule_end: formatDateToISO(value)
							}));
						}}
						paddingInLineEnd
					/>
				</S.inputsDate>

				<Check
					text="Contagem regressiva"
					isChecked={dataForm.countdown}
					setIsChecked={() => {
						setDataForm((obj) => ({
							...obj,
							countdown: !obj.countdown
						}));
					}}
				/>
			</div>
		</S.container>
	);
}
